import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { isDocumentActivity, isGraphActivity, parseThirdPartyARI, isRemoteLinkActivity } from '@atlassian/search-client';
import { getGenericUrlWithAnalyticsQueryParams, transformAriToId } from '@atlassian/search-common';
import { dateFormatter } from '../utils/date-formatter';
import { ProductIcon, Products } from './icons/product-icon';
import { FormattedMessage } from 'react-intl-next';
import { messages } from './messages';
import { getFrontendExperiment } from '@atlassian/search-experiment';
var typeLabelContainer = xcss({
  '::first-letter': {
    textTransform: 'capitalize'
  }
});
export var getDocumentSubtypeLabel = function getDocumentSubtypeLabel(_ref) {
  var product = _ref.product,
    subtype = _ref.subtype;
  if (!product || !subtype) {
    return;
  }
  var SUBTYPE_DOCUMENT = 'DOCUMENT';
  var SUBTYPE_PRESENTATION = 'PRESENTATION';
  var SUBTYPE_SPREADSHEET = 'SPREADSHEET';
  var GOOGLE_LABELS = _defineProperty(_defineProperty(_defineProperty({}, SUBTYPE_DOCUMENT, messages.googleDocsLabel), SUBTYPE_PRESENTATION, messages.googleSlidesLabel), SUBTYPE_SPREADSHEET, messages.googleSheetsLabel);
  var MICROSOFT_LABELS = _defineProperty(_defineProperty(_defineProperty({}, SUBTYPE_DOCUMENT, messages.msWordLabel), SUBTYPE_PRESENTATION, messages.msPowerpointLabel), SUBTYPE_SPREADSHEET, messages.msExcelLabel);
  var normalizedSubtype = subtype === null || subtype === void 0 ? void 0 : subtype.toUpperCase();
  var label;
  if (product === Products.Sharepoint || product === Products.OneDrive) {
    label = MICROSOFT_LABELS[normalizedSubtype];
  } else if (product.includes(Products.GoogleDrive)) {
    label = GOOGLE_LABELS[normalizedSubtype];
  }
  return label;
};
export var getRemoteLinkSubtypeLabel = function getRemoteLinkSubtypeLabel(_ref2) {
  var product = _ref2.product,
    subtype = _ref2.subtype;
  if (!product || !subtype) {
    return;
  }
  var labelKey = "".concat(subtype, "Label");
  if (labelKey in messages) {
    return messages[labelKey];
  } else {
    return messages.otherLabel;
  }
};
var mapConfluenceActivityToSearchResult = function mapConfluenceActivityToSearchResult(activity) {
  if (!activity.object.data) {
    return;
  }
  var id = activity.object.id;
  var _activity$object$data = activity.object.data,
    title = _activity$object$data.title,
    space = _activity$object$data.space,
    links = _activity$object$data.links;
  var icon = /*#__PURE__*/React.createElement(ProductIcon, {
    productKey: Products.Confluence
  });
  var spaceName = (space === null || space === void 0 ? void 0 : space.name) || '';
  var timestamp = activity.event.timestamp;
  var eventType = activity.event.eventType;
  var urlBase = links === null || links === void 0 ? void 0 : links.base;
  var urlWebUi = links === null || links === void 0 ? void 0 : links.webUi;
  var url = urlBase && urlWebUi && "".concat(urlBase).concat(urlWebUi);
  if (!title || !url) {
    return undefined;
  }
  return {
    id: id,
    url: url,
    icon: icon,
    type: activity.object.type,
    title: title,
    meta: spaceName,
    containerId: transformAriToId((space === null || space === void 0 ? void 0 : space.id) || 'UNAVAILABLE', 'space'),
    additionalMeta: timestamp ? dateFormatter(timestamp, true, eventType) : ''
  };
};
var mapJiraActivityToSearchResult = function mapJiraActivityToSearchResult(activity) {
  var _fieldsById$edges;
  if (!activity.object.data) {
    return;
  }
  var id = activity.object.id;
  var _activity$object$data2 = activity.object.data,
    key = _activity$object$data2.key,
    fieldsById = _activity$object$data2.fieldsById,
    webUrl = _activity$object$data2.webUrl;
  var icon = /*#__PURE__*/React.createElement(ProductIcon, {
    productKey: Products.Jira
  });
  var summary = fieldsById === null || fieldsById === void 0 || (_fieldsById$edges = fieldsById.edges) === null || _fieldsById$edges === void 0 || (_fieldsById$edges = _fieldsById$edges[0]) === null || _fieldsById$edges === void 0 || (_fieldsById$edges = _fieldsById$edges.node) === null || _fieldsById$edges === void 0 ? void 0 : _fieldsById$edges.text;
  var title = key && summary && "".concat(key, ": ").concat(summary);
  var timestamp = activity.event.timestamp;
  var eventType = activity.event.eventType;
  var meta = /*#__PURE__*/React.createElement(Box, {
    xcss: typeLabelContainer
  }, activity.object.type);
  if (!title || !webUrl) {
    return undefined;
  }
  return {
    id: id,
    url: webUrl,
    icon: icon,
    type: activity.object.type,
    title: title,
    meta: meta,
    containerId: '',
    additionalMeta: timestamp ? dateFormatter(timestamp, true, eventType) : ''
  };
};
var mapTownsquareActivityToSearchResult = function mapTownsquareActivityToSearchResult(activity) {
  if (!activity.object.data) {
    return;
  }
  var id = activity.object.id;
  var _activity$object$data3 = activity.object.data,
    name = _activity$object$data3.name,
    key = _activity$object$data3.key,
    url = _activity$object$data3.url;
  var icon = /*#__PURE__*/React.createElement(ProductIcon, {
    productKey: Products.Atlas
  });
  var timestamp = activity.event.timestamp;
  var eventType = activity.event.eventType;
  if (!name || !url) {
    return undefined;
  }
  return {
    id: id,
    url: url,
    icon: icon,
    type: activity.object.type,
    title: name,
    meta: key,
    containerId: '',
    additionalMeta: timestamp ? dateFormatter(timestamp, true, eventType) : ''
  };
};
var mapGraphDocumentActivityToSearchResult = function mapGraphDocumentActivityToSearchResult(activity) {
  var _type$category;
  if (!activity.object.data) {
    return;
  }
  var _activity$object$data4 = activity.object.data,
    type = _activity$object$data4.type,
    displayName = _activity$object$data4.displayName,
    parent = _activity$object$data4.parent,
    url = _activity$object$data4.url;
  var id = activity.object.id;
  var _parseThirdPartyARI = parseThirdPartyARI(id),
    resourceOwner = _parseThirdPartyARI.resourceOwner;
  var resourceType = resourceOwner.split('.').at(1);
  var product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
  if (!Object.values(Products).includes(product)) {
    return;
  }
  var title = displayName;
  if (!title || !url) {
    return undefined;
  }
  var icon = /*#__PURE__*/React.createElement(ProductIcon, {
    productKey: product
  });
  var timestamp = activity.event.timestamp;
  var eventType = activity.event.eventType;
  var subtype = type === null || type === void 0 || (_type$category = type.category) === null || _type$category === void 0 ? void 0 : _type$category.toLowerCase();
  var label = getDocumentSubtypeLabel({
    product: product,
    subtype: subtype
  });
  var typeLabel = label ? /*#__PURE__*/React.createElement(Box, {
    xcss: typeLabelContainer
  }, /*#__PURE__*/React.createElement(FormattedMessage, label)) : subtype ? /*#__PURE__*/React.createElement(Box, {
    xcss: typeLabelContainer
  }, subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()) : null;
  return {
    id: id,
    url: url,
    icon: icon,
    type: type,
    title: title,
    meta: typeLabel,
    containerId: (parent === null || parent === void 0 ? void 0 : parent.id) || 'UNAVAILABLE',
    additionalMeta: timestamp ? dateFormatter(timestamp, true, eventType) : ''
  };
};
var mapGraphRemoteLinkActivityToSearchResult = function mapGraphRemoteLinkActivityToSearchResult(activity) {
  if (!activity.object.data) {
    return;
  }
  var _activity$object$data5 = activity.object.data,
    displayName = _activity$object$data5.displayName,
    category = _activity$object$data5.category,
    url = _activity$object$data5.url;
  var id = activity.object.id;
  var _parseThirdPartyARI2 = parseThirdPartyARI(id),
    resourceOwner = _parseThirdPartyARI2.resourceOwner;
  var resourceType = resourceOwner.split('.').at(1);
  var product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
  if (!Object.values(Products).includes(product)) {
    return;
  }
  var title = displayName;
  if (!title || !url) {
    return undefined;
  }
  var icon = /*#__PURE__*/React.createElement(ProductIcon, {
    productKey: product
  });
  var timestamp = activity.event.timestamp;
  var eventType = activity.event.eventType;
  var subtype = category === null || category === void 0 ? void 0 : category.toLowerCase();
  var label = getRemoteLinkSubtypeLabel({
    product: product,
    subtype: subtype
  });
  var typeLabel = label ? /*#__PURE__*/React.createElement(Box, {
    xcss: typeLabelContainer
  }, /*#__PURE__*/React.createElement(FormattedMessage, label)) : subtype ? /*#__PURE__*/React.createElement(Box, {
    xcss: typeLabelContainer
  }, subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()) : null;
  return {
    id: id,
    url: url,
    icon: icon,
    type: category,
    title: title,
    meta: typeLabel,
    containerId: 'UNAVAILABLE',
    additionalMeta: timestamp ? dateFormatter(timestamp, true, eventType) : ''
  };
};
var _getFrontendExperimen = getFrontendExperiment({
    abTestId: 'smartlinks_in_quickfind'
  }),
  serveSmartLinksInQuickfind = _getFrontendExperimen.serveExperiment;
var mapGraphActivityToSearchResult = function mapGraphActivityToSearchResult(activity) {
  if (isDocumentActivity(activity.object)) {
    return mapGraphDocumentActivityToSearchResult(activity);
  }
  if (isRemoteLinkActivity(activity.object) && serveSmartLinksInQuickfind) {
    return mapGraphRemoteLinkActivityToSearchResult(activity);
  }
  return undefined;
};
export var mapRecentActivitiesToSearchResult = function mapRecentActivitiesToSearchResult(edge, searchSessionId) {
  var activity = edge.node;
  var product = activity.object.product;
  var result = isGraphActivity(activity.object) ? mapGraphActivityToSearchResult(activity) : product === 'confluence' ? mapConfluenceActivityToSearchResult(activity) : product === 'jira' ? mapJiraActivityToSearchResult(activity) : product === 'townsquare' ? mapTownsquareActivityToSearchResult(activity) : undefined;
  if (!result) {
    return undefined;
  }
  var urlWithAnalyticsQueryParams = getGenericUrlWithAnalyticsQueryParams({
    url: result.url,
    searchSessionId: searchSessionId
  });
  return _objectSpread(_objectSpread({}, result), {}, {
    url: urlWithAnalyticsQueryParams
  });
};